import { generateUrl } from '../../util';
import { ROUTES } from '@constants/routes';
import type { History } from 'history';
import type { UniversalTrackerModalServiceUtrv } from '@g17eco/types/universalTrackerValue';

interface NavigateToQuestionFromUtrvParams {
  initiativeId: string;
  utrv: Pick<UniversalTrackerModalServiceUtrv, '_id' | 'compositeData' | 'disaggregation'>;
  history: History;
}

/**
 * Navigates to the question detail page for a given UTRV.
 * Handles both normal case and disaggregation case.
 * This is the same logic used in UtrvLink component.
 */
export const navigateToQuestionFromUtrv = ({
  initiativeId,
  utrv,
  history,
}: NavigateToQuestionFromUtrvParams): void => {
  // Check if data from children (disaggregation)
  if ('disaggregation' in utrv && utrv.disaggregation) {
    const disaggregationUtrv = utrv.disaggregation[0];
    if (!disaggregationUtrv?.compositeData?.surveyId) {
      return;
    }
    const rootUrl = generateUrl(ROUTES.COMPANY_TRACKER_SURVEY, {
      initiativeId,
      surveyId: disaggregationUtrv.compositeData.surveyId,
      page: 'question',
    });
    const url = `${rootUrl}/${disaggregationUtrv._id}`;
    history.push(url);
    return;
  }

  // Normal case
  if (!utrv.compositeData?.surveyId) {
    return;
  }
  const rootUrl = generateUrl(ROUTES.COMPANY_TRACKER_SURVEY, {
    initiativeId,
    surveyId: utrv.compositeData.surveyId,
    page: 'question',
  });
  const url = `${rootUrl}/${utrv._id}`;
  history.push(url);
};
